import { isEqual } from 'lodash/fp'
import * as v from 'valibot'

import { validatedLocalStorage } from './validatedLocalStorage'

type PersistCause = 'preload' | 'enter' | 'stay'

/**
 * Persist a route's search params in local storage and restore them when
 * navigating back to the route. Assemble the route's `linkOptions` from
 * `get` and call `persist` from its `beforeLoad`.
 */
export function createPersistedSearchParams<TSchema extends v.GenericSchema>(
  key: string,
  schema: TSchema,
) {
  const get = () => validatedLocalStorage.getItem(key, schema)

  return {
    get,
    persist: (cause: PersistCause, search: v.InferOutput<TSchema>) => {
      if (cause === 'preload') return

      if (!isEqual(get(), search)) {
        validatedLocalStorage.setItem(key, schema, search)
      }
    },
  }
}
